import Base from 'base.service';

export default class PasswordRecovery extends Base {
  constructor($http, $cookies) {
    'ngInject';
    super($http);

    this.$cookies = $cookies;
  }

  sendRequest(requestData) {
    return this.$http.put(`${this.pingstaApiUrl}/passwords.json`, requestData)
      .then((response) => {
        const token = response.data.access_token;
        this.$cookies.put('token', token);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/screens/guest/screens/password-recovery/util/password-recovery.service.js